import { Route, Redirect } from 'react-router'
import PropTypes from 'prop-types'
import React from 'react'

const PrivilegedRoute = (props) => {
  const { location, authenticated } = props
  if (authenticated) {
    return <Route {...props} />
  }
  const to = {
    ...location,
    pathname: '/',
    state: {
      referrer: location.pathname
    }
  }
  return <Redirect to={to} push />
}

PrivilegedRoute.propTypes = {
  location: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired
}

export default PrivilegedRoute



// WEBPACK FOOTER //
// ./src/components/routing/PrivilegedRoute.js